import { FormHeader, FormRow } from '@creditornot/cb-form';
import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

const Confirm = () => {
  const intl = useIntl();
  return (
    <>
      <FormHeader>
        <FormattedMessage id="venue-data-collection.venue-information-form.general" />
      </FormHeader>
      <Field<string | undefined> name="name">
        {({ input }) => (
          <FormRow label={intl.formatMessage({ id: 'venue-data-collection.venue-information-form.name' })}>
            {input.value || '-'}
          </FormRow>
        )}
      </Field>
      <Field<string | undefined> name="address">
        {({ input }) => (
          <FormRow label={intl.formatMessage({ id: 'venue-data-collection.venue-information-form.address' })}>
            {input.value || '-'}
          </FormRow>
        )}
      </Field>
      <Field<string | undefined> name="website">
        {({ input }) => (
          <FormRow label={intl.formatMessage({ id: 'venue-data-collection.venue-information-form.website' })}>
            {input.value || '-'}
          </FormRow>
        )}
      </Field>
    </>
  );
};

export default Confirm;
